import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import { useInstantSearch } from "react-instantsearch";

import { useBreakpoint } from "~/contexts/breakpoint";
import { useConfiguration } from "~/contexts/configuration";

import HighlightedText from "../common/highlighted-text";
import { Hit } from "../products/search-product-grid-algolia";
import styles from "./no-results.module.scss";
import { searchClient } from "./search-client";

export default function NoResults() {
  const t = useTranslations();
  const { results } = useInstantSearch();
  const { algoliaIndexId } = useConfiguration();
  const breakpoint = useBreakpoint();
  const [defaultHits, setDefaultHits] = useState<any[]>([]);

  useEffect(() => {
    if (results && results.nbHits === 0) {
      searchClient
        .initIndex(algoliaIndexId)
        .search("", { hitsPerPage: breakpoint == "desktop" ? 8 : 6 })
        .then(({ hits }) => {
          setDefaultHits(hits);
        });
    }
  }, [algoliaIndexId, breakpoint, results]);

  if (results && results.nbHits === 0) {
    return (
      <div>
        <h3 className={styles.title}>
          <HighlightedText text={t("generic.noResultsTitle")} />
        </h3>
        <div className={styles.defaultHits}>
          {defaultHits.map((hit, i) => (
            <Hit hit={hit} key={i} index={i} />
          ))}
        </div>
      </div>
    );
  }
  return null;
}
